const coursesData = [
  {
    title: "React Developer Course",
    image:
      "https://res.cloudinary.com/practicaldev/image/fetch/s--V068QLqC--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/jbux8kukb9osdpqwc2sm.png",

    link: "/",
  },
  {
    title: "Node JS Course",
    image:
      "https://bs-uploads.toptal.io/blackfish-uploads/components/blog_post_page/content/cover_image_file/cover_image/686461/cover-secure-rest-api-in-nodejs-18f43b3033c239da5d2525cfd9fdc98f.png",

    link: "/",
  },
  {
    title: "MERN Stack Bootcamp",
    image:
      "https://res.cloudinary.com/practicaldev/image/fetch/s--2a-_OwgW--/c_imagga_scale,f_auto,fl_progressive,h_900,q_auto,w_1600/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/sm5uwpip9yglugcc15h4.png",

    link: "/",
  },
  {
    title: "HTML+CSS+Bootstrap",
    image:
      "https://media.onlinecoursebay.com/2019/03/19033724/1890026_f604_4.jpg",

    link: "/",
  },
  {
    title: "Fullstack Web Development",
    image: "https://miro.medium.com/max/750/1*-hL6ZeXl_Kt0O-b82UQo9A.png",

    link: "/",
  },
  {
    title: "Javascript Mastery",
    image:
      "https://cdn2.vectorstock.com/i/1000x1000/69/16/javascript-programming-language-with-script-code-vector-21946916.jpg",

    link: "/",
  },
];

export default coursesData;
